import { defineMessages } from 'react-intl';

export const dqlEditorMessages = defineMessages({
  openPanel: {
    defaultMessage: 'Open',
    id: 'QPVwTdDxajDwh62B',
    description:
      'Label next to the Ctrl+Space keyboard shortcut in the DQL editor autocomplete info section, describing the action the shortcut triggers.',
  },
  closePanel: {
    defaultMessage: 'Close',
    id: 'i7ML7nsvim1vfXlT',
    description:
      'Label next to the Esc keyboard shortcut in the DQL editor autocomplete info section, describing the action the shortcut triggers.',
  },
  dqlSyntaxLink: {
    defaultMessage: 'DQL syntax',
    id: 'anCkyfyzovTz3qtv',
    description:
      'Link text in the DQL editor autocomplete info section, pointing to the external DQL syntax documentation.',
  },
  suggestionDocumentationLink: {
    defaultMessage: 'Documentation',
    id: 'VimibV2KF+yA1+4y',
    description:
      'Link text in the DQL editor autocomplete suggestion detail tooltip, pointing to the external documentation for the selected command, function, or timeseries aggregation.',
  },
  suggestionSyntaxLabel: {
    defaultMessage: 'Syntax:',
    id: 'bIs/Bx2b6NyF7Hpe',
    description:
      'Label preceding the DQL syntax code example in the DQL editor autocomplete suggestion detail tooltip.',
  },
});
